<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="contact"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <g id="Group_719" data-name="Group 719" transform="translate(3.5 2.333)">
      <path
        id="Path_8079"
        data-name="Path 8079"
        d="M10.093,14.57c2.547,2.548,5.774,4.172,7.693,2.261l.465-.466a1.4,1.4,0,0,0-.185-2.145c-.454-.316-.941-.656-1.481-1.035a1.416,1.416,0,0,0-1.807.148l-.526.523a11.281,11.281,0,0,1-1.9-1.542l0,0a11.234,11.234,0,0,1-1.542-1.9l.523-.526A1.414,1.414,0,0,0,11.48,8.08c-.379-.538-.719-1.024-1.032-1.477A1.4,1.4,0,0,0,8.3,6.415l-.466.465c-1.91,1.919-.287,5.144,2.26,7.693"
        transform="translate(-2.333 -1.333)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_8080"
        data-name="Path 8080"
        d="M15.833,23,13.5,25.333,11.167,23H6.5A3.5,3.5,0,0,1,3,19.5V5.5A3.5,3.5,0,0,1,6.5,2h14A3.5,3.5,0,0,1,24,5.5v14A3.5,3.5,0,0,1,20.5,23Z"
        transform="translate(-3 -2)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
    <path id="Path_8081" data-name="Path 8081" d="M0,0H28V28H0Z" fill="none" />
  </svg>
</template>
